import React, { useState, useMemo } from 'react';
import TableFooter from './TableFooter.tsx';
//import SearchBar from '../SearchBar/SearchBar.tsx';
import TableHeader from "./TableHeader.tsx";
import { Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Paper } from '@mui/material';

interface Column<T> {
  key: keyof T | string;
  title?: string;
  renderCell?: (row: T) => React.ReactNode;
  width?: string;
}

interface UniversalTableProps<T> {
  data: T[];
  columns: Column<T>[];
  onRowClick?: (row: T, index: number, event: React.MouseEvent) => void;
  searchValue: string;
  onSearchChange: (value: string) => void;
  onCreate?: () => void;
  onImport?: () => void;
  onFilterClick?: () => void;
  sortColumn?: string | null;
  sortDirection?: 'asc' | 'desc' | null;
  onSort?: (columnKey: string) => void;
  totalCount: number;
  page: number;
  pageSize: number;
  onChangePage: (page: number) => void;
  onChangePageSize: (size: number) => void;
}

const UniversalTable = <T extends Record<string, any>>({
  data,
  columns,
  onRowClick,
  searchValue,
  onSearchChange,
  onCreate,
  onImport, 
  onFilterClick,
  sortColumn,
  sortDirection,
  onSort,
  totalCount,
  page,
  pageSize,
  onChangePage,
  onChangePageSize,
}: UniversalTableProps<T>) => {
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(event.target.value);
  };

  return (
    <TableContainer component={Paper}>
       <TableHeader
        searchValue={searchValue}
        onSearchChange={onSearchChange}
        onImport={onImport}
        onCreate={onCreate}
        onFilterClick={onFilterClick}
      />
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((col, index) => (
              <TableCell key={index} style={{ width: col.width }}>{col.title}</TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((row, rowIndex) => (
            <TableRow
              key={rowIndex}
              hover
              onClick={(e) => onRowClick && onRowClick(row, rowIndex, e)}
              style={{ cursor: onRowClick ? 'pointer' : 'default' }}
            >
              {columns.map((col, colIndex) => (
                <TableCell key={colIndex} style={{ width: col.width }}>
                  {col.renderCell ? col.renderCell(row) : row[col.key as keyof T]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>

        
      </Table>
      <TableFooter
          currentPage={page}
          totalRecords={totalCount}
          rowsPerPage={pageSize}
          onPageChange={onChangePage}
          onRowsPerPageChange={onChangePageSize}
          colSpan={columns.length}
          visibleRecordsCount={data.length}
        />
    </TableContainer>
  );
};

export default UniversalTable;
